import { render } from "./box-selector.vue?vue&type=template&id=0c299ada&scoped=true"
import script from "./box-selector.vue?vue&type=script&lang=js"
export * from "./box-selector.vue?vue&type=script&lang=js"

import "./box-selector.vue?vue&type=style&index=0&id=0c299ada&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c299ada"]])

export default __exports__